import React, { useEffect, useState } from 'react';
import { ArrowDown } from 'lucide-react';
import { Link } from 'react-scroll';
import { Button } from './ui/button';

const HeroSection = () => {
  const [scrollY, setScrollY] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <section id="hero" className="hero-section">
      {/* Animated gradient mesh background */}
      <div className="hero-background">
        <div className="gradient-mesh"></div>
        <div className="grain-overlay"></div>
        
        {/* Floating animated shapes */}
        <div 
          className="geometric-shape shape-1" 
          style={{ 
            transform: `translate(${mousePosition.x * 0.02}px, ${mousePosition.y * 0.02}px) rotate(${scrollY * 0.1}deg)` 
          }}
        ></div>
        <div 
          className="geometric-shape shape-2" 
          style={{ 
            transform: `translate(${-mousePosition.x * 0.015}px, ${-mousePosition.y * 0.015}px) rotate(${-scrollY * 0.15}deg)` 
          }}
        ></div>
        <div className="geometric-shape shape-3"></div>
        
        {/* Floating orbs */}
        <div className="floating-orb orb-1"></div>
        <div className="floating-orb orb-2"></div>
        <div className="floating-orb orb-3"></div>
      </div>

      <div className="hero-content">
        <div className="hero-text-container">
          <h1 className="hero-headline fade-in-up">
            We Help Our Clients <span className="gradient-text">Adapt to Change</span>
          </h1>
          
          <div className="hero-statement fade-in-up delay-1">
            <h2 className="hero-statement-title">Adaptive Intelligence. By Design.</h2>
            <p className="hero-statement-subtitle">Building clarity, capability, and resilience</p>
          </div>

          <div className="hero-cta-group fade-in-up delay-2">
            <div className="scroll-indicator-inline">
              <Link to="approach" smooth={true} duration={800} offset={-80}>
                <ArrowDown className="scroll-arrow" size={24} />
              </Link>
            </div>
            
            <Link to="capabilities" smooth={true} duration={800} offset={-80}>
              <Button className="hero-cta-primary button-press">
                Explore Our Work
              </Button>
            </Link>
            <Link to="approach" smooth={true} duration={800} offset={-80}>
              <Button variant="outline" className="hero-cta-secondary button-press">
                Our Approach
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;